<script>
import stronglyAgree from '@/images/stronglyAgree.png';
import agree from '@/images/agree.png';
import neutral from '@/images/noAgreeOrDisagree.png';
import disagree from '@/images/disagree.png';
import stronglyDisagree from '@/images/stronglyDisagree.png';
import axios from 'axios';
import config from '@/utils/config';

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      questions: [
        { id: 1, text: "1. Preferisco ricevere le ripetizioni online invece che in presenza.", answer: null },
        { id: 2, text: "2. Preferisco ricevere ripetizioni da altri studenti/studentesse online rispetto che in presenza.", answer: null },
        { id: 3, text: "3. Preferisco ricevere le ripetizioni con questa app rispetto ad usare applicazioni come Google Meet, Zoom, ecc.", answer: null},
        { id: 4, text: "4. Mi piace ricevere ripetizioni da altri studenti/studentesse usando quest’app rispetto ad usare applicazioni come Google Meet, Zoom, ecc. Perchè?", type: "text", answer: null },
        { id: 5, text: "5. È stato facile muovermi tra le stanze virtuali dell’applicazione.", answer: null},
        { id: 6, text: "6. Ho trovato comodo essere trasportato/a nella stanza virtuale della ripetizione con un click.", answer: null},
      ],
      subQuestions: {
        7: {
          id: "3.a",
          text: "3.a. Perché?",
          type: "checkbox",
          options: [
            { label: "Mi sento più a mio agio", value: "Mi sento piu a mio agio" },
            { label: "È più divertente", value: "Piu divertente" },
            { label: "Imparo di più", value: "Imparo di piu" },
            { label: "Non mi devo spostare", value: "Non mi devo spostare" },
            { label: "Altro", value: "Altro"}
          ],
          answer: null
        }
      },
      responseOptions: [
        { emoji: stronglyDisagree, value: 1, label: "Fortemente in disaccordo" },
        { emoji: disagree, value: 2, label: "In disaccordo" },
        { emoji: neutral, value: 3, label: "Neutro" },
        { emoji: agree, value: 4, label: "D'accordo" },
        { emoji: stronglyAgree, value: 5, label: "Fortemente d'accordo" },
      ],
    };
  },
  computed: {
    allAnswered() {
      return this.questions.every(question => 
        question.answer !== null && (Array.isArray(question.answer) ? question.answer.length > 0 : true)
      );
  }
  },
  methods: {
    setAnswer(question, option) {
      if (question.type === "checkbox") {
        if (!question.answer) question.answer = [];
        const index = question.answer.indexOf(option.value);
        if (index > -1) {
          question.answer.splice(index, 1); 
        } else {
          question.answer.push(option.value);
        }
      } else {
        question.answer = option.value;
      }
    },
    submitAnswers() {
      const payload = {
        preferiscoOnline: this.questions[0].answer,
        preferiscoOnlineStudenti: this.questions[1].answer,
        preferiscoApp: this.questions[2].answer,
        preferiscoAppPerche: this.questions[3].answer, 
        preferiscoAppRispetto: this.subQuestions[7].answer, 
        facileMuoversi: this.questions[4].answer,
        comodoTrasporto: this.questions[5].answer,
        user: { id: this.user.id }
      };
      axios.post(config.baseUrl + `/finalRepetitionQuestionnaire/addScores`, payload)
        .then(() => {
          this.$emit('finished');
        })
        .catch(error => {
          console.error('Error posting questionnaire:', error);
        });
    }
  },
};
</script>

<template>
  <div class="survey-wrapper">
    <h3>Questionario di fine sperimentazione</h3>
    <p class="description">Giunto a questo punto della sperimentazione vogliamo sapere la tua opinione.</p>
    <p class="description">Questo sarà l'ultimo questionario che ti proporremo.</p>
    
    <div class="survey-container">
      <div v-for="question in questions" :key="question.id" class="question-item">
        <p class="question-text">{{ question.text }}</p>
        <div class="options">          
          <div v-if="question.type === 'text'" class="text-answer">
            <textarea v-model="question.answer" placeholder="Scrivi la tua risposta qui..." rows="4"></textarea>
          </div>
          <div v-if="question.type !== 'checkbox' && question.type !== 'text'">
            <button
              v-for="option in responseOptions"
              :key="option.value"
              @click="setAnswer(question, option)"
              :class="{ selected: question.answer === option.value }">
              <img :src="option.emoji" alt="emoji" class="emoji-img" />
              <span class="option-label">{{ option.label }}</span>
            </button>
          </div>
          <div v-if="question.id === 3" class="question-item sub-question">
            <p class="question-text">{{ subQuestions[7].text }}</p>
            <div class="options">
              <div v-for="option in subQuestions[7].options" :key="option.value" class="checkbox-option">
                <input 
                  type="radio"
                  :id="option.value"
                  :value="option.value"
                  v-model="subQuestions[7].answer" />
                <label :for="option.value">{{ option.label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="navigation">
        <button @click="submitAnswers" :disabled="!allAnswered">Invia Risposte</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
  caret-color: transparent;
  box-sizing: border-box;
} 

.survey-wrapper {
  width: 50%;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  font-family: 'Arial', sans-serif;
}

h3 {
  font-size: 26px;
  color: white;
  font-weight: bold;
  margin-bottom: 10px;
}

.description {
  font-size: 16px;
  color: white;
  margin-bottom: 20px;
  line-height: 1.6;
}

.survey-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.question-item {
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.question-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
}

.options {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.options > div {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.checkbox-option label {
  color: #333;
}

.options button {
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  font-size: 14px;
  width: 120px;
  text-align: center;
  flex-shrink: 0; 
}

.options button img {
  width: 40px;
  height: 40px;
}

.options button:hover {
  background-color: #e0e0e0;
  transform: scale(1.05);
}

.options button.selected {
  background-color: #cce5ff;
  border-color: #007bff;
}

.emoji-img {
  width: 40px;
  height: 40px;
}

.options button:hover {
  background-color: #e0e0e0;
  transform: scale(1.05);
}

.options button.selected {
  background-color: #cce5ff;
  border-color: #007bff;
}

.submit-btn {
  margin-top: 20px;
  padding: 12px 30px;
  font-size: 18px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background-color: #0056b3;
}

.submit-btn:disabled {
background-color: #ccc;
cursor: not-allowed;
}

.navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.navigation button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.navigation button:hover {
  background-color: #0056b3;
}

.navigation button:disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
  transition: none;
}

.checkbox-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 5px;
}

.text-answer{
  width: 80%;
}

.text-answer textarea {
  width: 100%;
  height: 120px; 
  padding: 12px;
  font-size: 12px; 
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none; 
  line-height: 1.5;
  caret-color: gray;
}

.sub-question {
  padding: 15px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center; 
  text-align: center;
}

.sub-question .question-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
}

.checkbox-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 5px;
}

</style>